const MAXIMUM_INDEX_OF_THE_SELECT = 4,
    MINIMUM_INDEX_OF_THE_SELECT = 1;

export default class Jumbotron {
    constructor() {
        this.$grids = $('.grid-2cols');
        this.$studentCardInput = $('.form-element-student-card');
        this.jumbotrons = [];
        $('.form-element-student-card label').text('Veuillez fournir votre carte d\'étudiant');
        this.getJumbotrons();
        this.changeBordersColor();
        this.changeStudentCardInputDisplay(false);
        this.toggleSubscriptionType(parseInt($('.subscription-type').val()));
        /**
         * 1 = membre actif, 2 = membre de soutien, 3 = membre actif étudiant, 4 = membre actif étudiant cinéma
         */
        $('.subscription-type').on('change', () => {
            this.toggleSubscriptionType(parseInt($('.subscription-type').val()));
        })

        $('.frame-jumbotron a').on('click', (event) => {
            event.preventDefault();
            $(event.target).prop('href', (_, oldHref) => {
                return oldHref + "#" + $(event.target).prop('title');
            });
            window.location.href = $(event.target).prop('href');
        });

        if($('.subscription-type').length > 0) {
            let selectValue = window.location.href.substring(window.location.href.indexOf("#")+1); /* Retrieving the value of the anchor */
            if(parseInt(selectValue) <= MAXIMUM_INDEX_OF_THE_SELECT && parseInt(selectValue) >= MINIMUM_INDEX_OF_THE_SELECT) {
                $('.subscription-type').val(selectValue);
                this.toggleSubscriptionType(parseInt(selectValue));
            }
            $('.student-card').on('change', () => {
                if($('.student-card').get(0).files.length === 0) {
                    $('.form-element-student-card label').text('Veuillez fournir votre carte d\'étudiant');
                } else {
                    $('.form-element-student-card label').text($('.student-card').get(0).files[0].name);
                }
            });
        }

        $('.form-actions button').on('click', (event) => {
            if($('.student-card').prop('required') && $('.student-card').get(0).files.length === 0 && $('.form-image img').length === 0) {
                alert('Veuillez renseigner votre carte d\'étudiant');
                event.preventDefault();
            }
        })
    }

    changeBordersColor() {
        if (this.jumbotrons.length > 0) {
            for(let i = 0; i < this.jumbotrons.length; i++) {
                if($(this.jumbotrons[i]).find('h1').hasClass('text-primary')){
                    $(this.jumbotrons[i]).addClass('border-primary');
                }
                else {
                    $(this.jumbotrons[i]).addClass('border-secondary');
                }
            }
        }
    }

    getJumbotrons() {
        if (this.$grids.length > 0) {
            for (let i = 0; i < this.$grids.length; i++) {
                this.jumbotrons.push($(this.$grids[i]).find('.frame-jumbotron'));
            }
        }
    }

    toggleSubscriptionType(value){
        switch(value) {
            case 1:
                $('.form-element-payment-method').show();
                this.changeStudentCardInputDisplay(false);
                break;
            case 2:
                $('.form-element-payment-method').show();
                this.changeStudentCardInputDisplay(false);
                break;
            case 3:
                $('.form-element-payment-method').show();
                this.changeStudentCardInputDisplay(true);
                break;
            case 4:
                $('.form-element-payment-method').hide();
                this.changeStudentCardInputDisplay(true);
                break;
        }
    }

    changeStudentCardInputDisplay(isDisplayed) {
        if(isDisplayed) {
            this.$studentCardInput.show();
            $('.student-card').prop('required', true);
        }
        else {
            this.$studentCardInput.hide();
            $('.student-card').prop('required', false);
        }
    }
}
